import { render } from "./TermsPolicy.vue?vue&type=template&id=5f13264a&scoped=true"
import script from "./TermsPolicy.vue?vue&type=script&lang=js"
export * from "./TermsPolicy.vue?vue&type=script&lang=js"

import "./TermsPolicy.vue?vue&type=style&index=0&id=5f13264a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f13264a"]])

export default __exports__